import * as React from 'react';

import { TabPanel } from '@coursera/cds-core';

import { AddCoursesToTermDialogProvider } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/context/AddCoursesToTermDialogContext';
import { AddTermsToPlanningToolDialogProvider } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/context/AddTermsToPlanningToolContext';
import { CoursePlanningDialogProvider } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/context/CoursePlanningDialogContext';
import { WithDPMDialog } from 'bundles/degree-home/components/v3-dpm/context/DPMDialogContext';
import { PartnerVariationProvider } from 'bundles/degree-home/components/v3-dpm/context/PartnerVariation';
import { ProgramVariationProvider } from 'bundles/degree-home/components/v3-dpm/context/ProgramVariation';
import { useRedirectIfNotV3 } from 'bundles/degree-home/components/v3-dpm/lib/experiments';
import { Container } from 'bundles/degree-home/components/v3-dpm/pages/pageStyles';

import { LearnerPlanStoreProvider } from '../context/LearnerPlanStoreContext';
import { TermStoreProvider } from '../context/TermStoreContext';

interface Props {
  pathToRedirectToIfNotV3: string;
  tabPanelValue: string;
}

/** Common container for both pages in degree home */
const PageContainer: React.FC<Props> = ({ pathToRedirectToIfNotV3, tabPanelValue, children }) => {
  useRedirectIfNotV3(pathToRedirectToIfNotV3);
  return (
    <TermStoreProvider>
      <PartnerVariationProvider>
        <ProgramVariationProvider>
          <LearnerPlanStoreProvider>
            <CoursePlanningDialogProvider>
              <AddTermsToPlanningToolDialogProvider>
                <AddCoursesToTermDialogProvider>
                  <WithDPMDialog>
                    <TabPanel value={tabPanelValue}>
                      <Container>{children}</Container>
                    </TabPanel>
                  </WithDPMDialog>
                </AddCoursesToTermDialogProvider>
              </AddTermsToPlanningToolDialogProvider>
            </CoursePlanningDialogProvider>
          </LearnerPlanStoreProvider>
        </ProgramVariationProvider>
      </PartnerVariationProvider>
    </TermStoreProvider>
  );
};

export default PageContainer;
